module.exports = __webpack_public_path__ + "static/media/1017094.f6f4649d.png";